export default __webpack_public_path__ + "static/media/stainless.0c160a8d.jpeg";